import { useState, type ReactNode } from 'react';
import { Box } from '@mui/material';
import { PageBannerTarget } from './usePageBannerTarget';

/** Page feedback stays above the content even when its editor lives in a nested panel. */
export function PageBannerRegion({ children }: { children: ReactNode }) {
  const [target, setTarget] = useState<HTMLDivElement | null>(null);
  return (
    <PageBannerTarget.Provider value={target}>
      <Box ref={setTarget} />
      {children}
    </PageBannerTarget.Provider>
  );
}
